class CartConfirmationPopup extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    this.shadowRoot.innerHTML = `
      <style>
        .cart-confirmation-popup {
          position: fixed;
          top: 60px;
          left: 50%;
          transform: translateX(-50%);
          background: #ffffff;
          padding: 0;
          border-radius: 6px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.08);
          z-index: 9999;
          opacity: 0;
          visibility: hidden;
          transition: all 0.3s ease;
          width: 420px;
          pointer-events: none;
        }

        .cart-confirmation-popup.show {
          opacity: 1;
          visibility: visible;
          pointer-events: auto;
        }

        .popup-header {
          display: flex;
          align-items: center;
          padding: 6px 12px;
          border-bottom: none;
          background: #ffffff;
          border-radius: 6px 6px 0 0;
          min-height: 28px;
        }

        .popup-header svg {
          width: 12px;
          height: 12px;
          margin-right: 6px;
          fill: #4CAF50;
        }

        .popup-header span {
          font-weight: 400;
          color: #4CAF50;
          font-size: 12px;
          line-height: 1;
        }

        .popup-content {
          padding: 8px 12px;
          border-top: 1px solid #f0f0f0;
        }

        .product-info {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .product-image {
          width: 45px;
          height: 45px;
          flex-shrink: 0;
          border: 1px solid #f0f0f0;
          border-radius: 4px;
        }

        .product-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 4px;
        }

        .product-details {
          flex-grow: 1;
        }

        .product-title {
          font-size: 13px;
          color: #333;
          margin: 0 0 1px;
          font-weight: 500;
        }

        .product-price {
          font-size: 14px;
          color: #666;
          font-weight: 400;
          display: flex;
          gap: 8px;
          align-items: center;
        }

        .product-price .price--end {
          color: #333;
        }

        .product-price .price--compare {
          text-decoration: line-through;
          color: #999;
        }

        @media screen and (max-width: 768px) {
          .cart-confirmation-popup {
            width: calc(100% - 32px);
            border-radius: 6px;
          }
          
          .popup-header {
            border-radius: 6px 6px 0 0;
          }
        }
      </style>
      <div class="cart-confirmation-popup" role="alert">
        <div class="popup-header">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/>
          </svg>
          <span>Item added to cart</span>
        </div>
        <div class="popup-content">
          <div class="product-info">
            <div class="product-image">
              <img class="product-image__img" src="" alt="">
            </div>
            <div class="product-details">
              <h4 class="product-title"></h4>
              <div class="product-price"></div>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  show(productData = {}) {
    const popup = this.shadowRoot.querySelector('.cart-confirmation-popup');
    const imgElement = this.shadowRoot.querySelector('.product-image__img');
    
    // Update product information
    if (productData.featured_image && productData.featured_image.url) {
      const imageUrl = productData.featured_image.url;
      // Add image size parameters if not present
      const finalImageUrl = imageUrl.includes('?') ? imageUrl : `${imageUrl}?width=65`;
      imgElement.src = finalImageUrl;
      imgElement.alt = productData.title || 'Product image';
    }

    if (productData.title) {
      this.shadowRoot.querySelector('.product-title').textContent = productData.title;
    }
    
    const priceElement = this.shadowRoot.querySelector('.product-price');
    if (priceElement) {
      priceElement.innerHTML = '';
      
      if (productData.compare_at_price) {
        const comparePrice = document.createElement('span');
        comparePrice.className = 'price--compare';
        comparePrice.textContent = productData.compare_at_price;
        priceElement.appendChild(comparePrice);
      }
      
      if (productData.price) {
        const finalPrice = document.createElement('span');
        finalPrice.className = 'price--end';
        finalPrice.textContent = productData.price;
        priceElement.appendChild(finalPrice);
      }
    }
    
    popup.classList.add('show');
    setTimeout(() => this.hide(), 3000);
  }

  hide() {
    const popup = this.shadowRoot.querySelector('.cart-confirmation-popup');
    popup.classList.remove('show');
  }
}

customElements.define('cart-confirmation-popup', CartConfirmationPopup); 